module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/MagicAdTileMobile-3ca357488d146c600caebad21bae6e38.png";